import { combineReducers } from "redux";
import userReducer from "./userReducer";
import loaderReducer from "./loaderReducer";
import chatsReducer from "./chatsReducer";
import domainReducer from "./domainReducer";
import TabStackReducer from "./tabStackReducer";
import {
	SnackbarReducer,
	NotificationReducer,
	CallNotificationReducer,
} from "./notificationReducer";
import modalReducer from "./modalReducer";
import { LOGOUT_USER } from "../constants";
import LayoutReducer from "./layoutReducer";
import botReducer from "./botReducer";
import contactsReducer from './contactsReducer'
import profileImagesReducer from "./profileImagesReducer";
import appNotificationsReducer from "./appNotificationsReducer";
import phoneReducer from './phoneReducer'
import catalogueReducer from "./catalogueReducer";
import offlineBannerReducer from "./offlineBannerReducer";
import channelsReducer from "./channelsReducer";
import socketReducer from "./socketReducer";
import {filterReducer} from "./filterReducer"

const appReducer = combineReducers({
	user: userReducer,
	loader: loaderReducer,
	chats: chatsReducer,
	domain: domainReducer,
	tabStack: TabStackReducer,
	notification: NotificationReducer,
	layout: LayoutReducer,
	CallNotification: CallNotificationReducer,
	modal: modalReducer,
	bot: botReducer,
	contacts: contactsReducer,
	profileImages: profileImagesReducer,
	appNotification: appNotificationsReducer,
	phone: phoneReducer,
	catalogue: catalogueReducer,
	offlineBanner: offlineBannerReducer,
	channels: channelsReducer,
	socket: socketReducer,
	filters:filterReducer
});

const rootReducer = (state, action) => {
	if (action.type === LOGOUT_USER) {
		state = undefined;
	}
	return appReducer(state, action);
};

export default rootReducer;
